import { ThemeEvents } from '@theme/events'

class VariantBestBefore extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateContent)
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateContent)
  }

  /**
   * @param {CustomEvent} event
   */
  updateContent = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return
    }

    const newNode = event.detail.data.html.querySelector('variant-best-before .text-block')
    const currentNode = this.querySelector('.text-block')
    if (!newNode || !currentNode) return
    if (currentNode.innerHTML !== newNode.innerHTML) {
      currentNode.innerHTML = newNode.innerHTML
    }
  }
}

customElements.define('variant-best-before', VariantBestBefore)


